import "./App.css";
import { Route, Routes } from "react-router-dom";
import { Login } from "./login";
import { Workspace } from "./workspace";
import { Context } from "./context";
import { useEffect, useId, useState } from "react";
import { Dashboard } from "./pages/datacenter/dashboard";
import { SingleReportPage } from "./pages/task/single_report";
import { apiClient } from "./services/api";
import { db } from "./services/database";
import { getCurrentUser } from "./services/login";
import { Toaster } from "@fluentui/react-components";

function App() {
    let [user, setUser] = useState(null);
    let [currentField, setCurrentField] = useState(null);
    let [loading, setLoading] = useState(true);
    const toasterId = useId();

    useEffect(() => {
        const initializeApp = async () => {
            try {
                const token = localStorage.getItem('token');
                const storedUser = getCurrentUser();

                if (!token) {
                    setUser(null);
                    return;
                }

                if (storedUser) {
                    setUser(storedUser);
                }

                try {
                    const currentUser = await apiClient.getCurrentUser();
                    setUser(currentUser);
                    localStorage.setItem('user', JSON.stringify(currentUser));
                } catch (error) {
                    console.error("Token validation failed:", error);
                    const isUnauthorized = (error?.status === 401) || (error?.message || "").toLowerCase().includes("unauthorized");
                    if (isUnauthorized && (error?.unauthorizedCount ?? 0) >= 3) {
                        apiClient.logout();
                        setUser(null);
                        return;
                    }
                    console.warn("Skipping logout; treating as transient authorization error", error);
                }

                try {
                    const fieldItems = await apiClient.getFieldItems();
                    if (fieldItems && fieldItems.length > 0) {
                        const savedFieldId = localStorage.getItem('currentFieldId');
                        const nextField = savedFieldId
                            ? fieldItems.find(f => f.id.toString() === savedFieldId)
                            : fieldItems[0];

                        if (nextField) {
                            setCurrentField(nextField);
                            localStorage.setItem('currentFieldId', nextField.id.toString());
                        }
                    }
                } catch (error) {
                    console.error("Failed to preload field items:", error);
                }
            } catch (error) {
                console.error("App initialization error:", error);
            } finally {
                setLoading(false);
            }
        };

        initializeApp();
    }, []);

    // Show loading state while initializing
    if (loading) {
        return (
            <div className="App" style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh' 
            }}>
                <div>加载中...</div>
            </div>
        );
    }

    return (
        <Context.Provider
            value={{
                user,
                setUser,
                currentField,
                setCurrentField,
                apiClient,
                db,
                // 在生产环境中使用相对路径，在开发环境中使用localhost
                oss: process.env.REACT_APP_OSS_ENDPOINT || 
                    (process.env.NODE_ENV === 'development' ? "http://localhost:9000" : ""),
                svr: process.env.REACT_APP_SVR_ENDPOINT || 
                    (process.env.NODE_ENV === 'development' ? "http://localhost:9002" : ""),
                toasterId,
            }}
        >
            <div className="App">
                <Toaster toasterId={toasterId} position="top-end" />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/*" element={<Workspace />} />
                    <Route
                        path="/task/report/:taskId"
                        element={<SingleReportPage />}
                    />
                </Routes>
            </div>
        </Context.Provider>
    );
}

export default App;
